const translations = {
    en: {
        customize: {
            header: "CUSTOMIZE YOUR STAY",
            title: "<strong>Your Stay.</strong><br/><strong>Your Choice.</strong>",
            text: "Discover all the available services to make your stay unique at ",
            notice: "The final price displayed at the time of booking is per stay per room.",
            empty_categories: "There are no available services at the moment."
        }
    },
    de: {
        customize: {
            header: "PASSEN SIE IHREN AUFENTHALT AN",
            title: "<strong>Ihr Aufenthalt.</strong><br/><strong>Ihre Wahl.</strong>",
            text: "Entdecken Sie alle verfügbaren Dienstleistungen, um Ihren Aufenthalt einzigartig zu machen ",
            notice: "Der zum Zeitpunkt der Buchung angegebene Endpreis versteht sich pro Aufenthalt und Zimmer.",
            empty_categories: "Momentan sind keine Dienstleistungen verfügbar."
        }
    },
    es: {
        customize: {
            header: "Personalize su estancia",
            title: "<strong>su Estancia.</strong><br/><strong>Su elección.</strong>",
            text: "Descubra todos los servicios que le ofrecemos para que su estancia sea única ",
            notice: "El precio final que se muestra en el momento de la reserva es por estancia por habitación.",
            empty_categories: "El servicio que usted eligió no se encuentra disponible, en este momento."
        }
    },
    fr: {
        customize: {
            header: "PERSONNALISEZ VOTRE SÉJOUR",
            title: "<strong>Faites votre voyage parfait.</strong>",
            text: "Découvrez tous les services proposés pour rendre votre séjour unique chez ",
            notice: "Le prix final affiché au moment de la réservation est par séjour par chambre.",
            empty_categories: "Désolé, il n'y a pas de services disponibles actuellement."
        }
    },
    it: {
        customize: {
            header: "PERSONALIZZA IL TUO SOGGIORNO",
            title: "<strong>Rendi perfetto il tuo viaggio.</strong>",
            text: "Scopri tutti i servizi a tua disposizione per rendere unico il tuo soggiorno al ",
            notice: "Al termine della prenotazione del prodotto visualizzerai il prezzo totale per soggiorno per camera.",
            empty_categories: "Non ci sono servizi prenotabili al momento."
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/customize/Customize.js